import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import GooglePhoneTracker from './components/GooglePhoneTracker';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import PricingPage from './pages/PricingPage';
import AreasPage from './pages/AreasPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ReviewsPage from './pages/ReviewsPage';
import Policies from './pages/Policies';
import FAQPage from './pages/FAQPage';
import PayDeposit from './pages/PayDeposit';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import QuotePage from './pages/QuotePage';
import ThankYouPage from './pages/ThankYouPage';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <GooglePhoneTracker />
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/areas" element={<AreasPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/faq" element={<FAQPage />} />
            
            {/* Quote System (FROZEN - do not modify) */}
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/get-a-quote" element={<QuotePage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            
            {/* Payment Pages (Inactive but preserved) */}
            <Route path="/pay-deposit" element={<PayDeposit />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
            
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
